import {
  Control,
  Controller,
  FieldErrors,
  UseFormClearErrors,
  UseFormGetValues,
  UseFormSetValue,
} from 'react-hook-form'
import { Alert } from '../../../../components/alerts/Alert'
import { TAutorizacionForm } from '../../models/autorizacionForm.type'
import { AlertDuracion } from './alertFechaVencimientoDuracion/AlertDuracion'
import { AlertFechaVencimiento } from './alertFechaVencimientoDuracion/AlertFechaVencimiento'

type Props = {
  isPorFechaVencimiento: boolean | undefined
  setAutorizacionIndefinida: (arg: boolean) => void
  isAutorizacionIndefinida: boolean | undefined
  setPorFechaVencimiento: (arg: boolean) => void
  isModoEditar: boolean
  calcularFechaCantidad: () => void
  cambiarCamposAutorizacionIndefinida: (
    valorRadioButtonIndefinida: boolean,
    valorRadioButtonFechaVencimiento: boolean
  ) => void
  control: Control<TAutorizacionForm>
  errors: FieldErrors<TAutorizacionForm>
  register: any
  getValues: UseFormGetValues<TAutorizacionForm>
  setValue: UseFormSetValue<TAutorizacionForm>
  clearErrors: UseFormClearErrors<TAutorizacionForm>
  usuarioPermiso?: boolean
}
export const DatosAutorizacionFormRadioBotones = ({
  isAutorizacionIndefinida,
  setAutorizacionIndefinida,
  isPorFechaVencimiento,
  setPorFechaVencimiento,
  isModoEditar,
  calcularFechaCantidad,
  cambiarCamposAutorizacionIndefinida,
  control,
  errors,
  register,
  getValues,
  setValue,
  clearErrors,
  usuarioPermiso,
}: Props) => {
  // Radio buttons que definen la estrategia de captura de vigencia.
  // 1) esIndefinida: oculta y limpia fecha/duracion; estatus se fuerza a "Vigente" en creacion.
  // 2) esPorFechaVencimiento: alterna entre captura por duracion vs fecha.
  /**
   * @description  Cambia el estado de isPorFecha Vencimiento cada que se realiza un click
   *              en el checkbox de esPorFechaVencimiento
   *
   * @author ana.carrasco  Hábil MX
   * @version 1.0.0, 20/12/2022
   */
  const cambiarCamposPorFechaVencimiento = (valorRadioButtonFechaVencimiento: boolean) => {
    // Al cambiar el modo, se limpia el set de campos del modo anterior.
    // Esto evita enviar una combinacion invalida (por ejemplo fechaVencimiento y unidad/cantidad).
    setPorFechaVencimiento(valorRadioButtonFechaVencimiento)
    setValue('esPorFechaVencimiento', valorRadioButtonFechaVencimiento)

    setAutorizacionIndefinida(false)
    calcularFechaCantidad()
    setValue('cantidadDuracion', 0)
    setValue('unidadDuracion', null)
    setValue('fechaVencimiento', null)
    if (!isPorFechaVencimiento) {
      clearErrors('cantidadDuracion')
      clearErrors('unidadDuracion')
    } else {
      clearErrors('fechaVencimiento')
      setValue('fechaVencimiento', null)
    }
  }

  return (
    <div className='col-12 justify-content-between '>
      <div className='d-flex'>
        <div className='col-5 mb-10 mt-10 form-check form-check-sm form-check-custom form-check-solid me-10'>
          {/* RADIO BOTONES*/}
          <h4 className='me-9'>¿La autorización tiene duración indefinida?</h4>
          {errors && errors['esIndefinida'] && (
            <p className='text-danger text-end fs-5'>{errors['esIndefinida']?.message}</p>
          )}

          <div className='col-2'>
            <Controller
              control={control}
              name={'esIndefinida'}
              render={({ field: { onChange } }) => (
                <>
                  <div
                    onClick={() => {
                      usuarioPermiso && cambiarCamposAutorizacionIndefinida(true, false)
                    }}>
                    <p className='mb-4 fs-5'>
                      <label htmlFor='si'>
                        <input
                          disabled={!usuarioPermiso}
                          {...register('esIndefinida', { required: true })}
                          className='form-check-input me-3'
                          value={true}
                          name='esIndefinida'
                          type='radio'
                          checked={isAutorizacionIndefinida === true ? true : false}
                          onChange={() => {
                            onChange(true)
                          }}
                          id='si'
                        />
                        Sí
                      </label>
                    </p>
                  </div>
                  <div
                    onClick={() => {
                      usuarioPermiso && cambiarCamposAutorizacionIndefinida(false, false)
                    }}>
                    <p className=' fs-5'>
                      <label htmlFor='no'>
                        <input
                          disabled={!usuarioPermiso}
                          {...register('esIndefinida', { required: true })}
                          value={false}
                          name='esIndefinida'
                          className='form-check-input me-3'
                          type='radio'
                          checked={isAutorizacionIndefinida === false ? true : false}
                          onChange={() => {
                            onChange(true)
                          }}
                          id='no'
                        />
                        No
                      </label>
                    </p>
                  </div>
                </>
              )}
            />
          </div>
          {errors && errors['esIndefinida'] && (
            <p className='text-danger text-end fs-5'>{errors['esIndefinida']?.message}</p>
          )}
        </div>
        <div className='col-1'></div>
        {!isModoEditar && isAutorizacionIndefinida && (
          <div className='  col-4 mt-2'>
            <Alert
              color='dark'
              mensaje='Una autorización con duración indefinida se crea siempre con un estatus vigente.'
            />
          </div>
        )}
      </div>
      <div
        style={isAutorizacionIndefinida ? { display: 'none' } : { height: '100px' }}
        className='col-6 mt-3 form-check form-check-sm form-check-custom form-check-solid me-10'>
        <h4
          className='fw-bold
                 text-gray-1000 me-5 col-7 me-12'>
          ¿Cómo quieres especificar la duración de la autorización?
        </h4>

        <div className='col-5 mb-2'>
          <Controller
            control={control}
            name={'esPorFechaVencimiento'}
            render={({ field: { onChange } }) => (
              <>
                <div
                  onClick={() => {
                    usuarioPermiso && cambiarCamposPorFechaVencimiento(false)
                  }}>
                  <p className='mb-4 fs-5'>
                    <label htmlFor='duracion'>
                      <input
                        disabled={!usuarioPermiso}
                        {...register('esPorFechaVencimiento', { required: true })}
                        value={false}
                        checked={isPorFechaVencimiento === false ? true : false}
                        className='form-check-input me-3'
                        type='radio'
                        name='esPorFechaVencimiento'
                        onChange={() => {
                          onChange(false)
                        }}
                        id='duracion'
                      />
                      Meses, días o años.
                    </label>
                  </p>
                </div>

                <div
                  onClick={() => {
                    usuarioPermiso && cambiarCamposPorFechaVencimiento(true)
                  }}>
                  <p className='fs-5'>
                    <label htmlFor='fechaVencimiento'>
                      <input
                        disabled={!usuarioPermiso}
                        {...register('esPorFechaVencimiento', { required: true })}
                        value={true}
                        checked={isPorFechaVencimiento === true ? true : false}
                        className='form-check-input me-3'
                        type='radio'
                        name='esPorFechaVencimiento'
                        onChange={() => {
                          onChange(true)
                        }}
                        id='fechaVencimiento'
                      />
                      Fecha Vencimiento
                    </label>
                  </p>
                </div>
              </>
            )}
          />
        </div>

        {errors && errors['esPorFechaVencimiento'] && (
          <p className='text-danger text-end fs-5'>{errors['esPorFechaVencimiento']?.message}</p>
        )}
        {isPorFechaVencimiento && (!getValues('fechaEmision') || !getValues('fechaVencimiento')) ? (
          <AlertFechaVencimiento getValues={getValues}></AlertFechaVencimiento>
        ) : (
          !isPorFechaVencimiento &&
          (!getValues('fechaEmision') ||
            !getValues('unidadDuracion') ||
            !getValues('cantidadDuracion')) && <AlertDuracion getValues={getValues}></AlertDuracion>
        )}
      </div>
    </div>
  )
}
